import styled from 'styled-components'

export const StyledUpload = styled.div`
  padding: 1rem;
  height: 30vh;

  .je-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 2rem;
    h4 {
      font-size: 2.5rem;
    }
    i {
      font-size: 2rem;
      margin-left: 1rem;
      //color: #0288BD;
    }
  }

  .submit {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 2rem;
  }

  .error-message,
  .success-message {
    position: absolute;
    bottom: 0;
    padding: 2rem;
  }
`
